'use client';

import { forwardRef } from 'react';
import IconBox from './icons/IconBox';
import { useIsMobile } from '@/hooks/useIsMobile';

export interface CardProps {
  id?: number;
  title: string;
  description: string;
  icon?: React.ComponentType;
  className?: string;
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ title, description, icon: Icon, className = '' }, ref) => {
    const isMobile = useIsMobile(768);

    return (
      <div
        ref={ref}
        className={`card 
      phone:p-4 tablet:p-6 desktop:p-8
      rounded-lg
      bg-gradient-to-t from-gray-800 to-gray-900
      shadow-[0_4px_8px_rgba(255,255,255,0.03)] 
      transform transition-all duration-300 
      hover:-translate-y-2 hover:shadow-[0_8px_16px_rgba(255,255,255,0.08)] 
      focus:ring-2 focus:ring-gray-500 focus:outline-none active:translate-y-0 
      w-full min-w-[280px] phone:min-w-[300px] tablet:min-w-[320px] desktop:min-w-[420px] desktopxl:min-w-[480px]
      h-full min-h-[450px] tablet:min-h-[450px] desktop:min-h-[450px] phone:min-h-[350px]
      flex flex-col
      text-center border border-gray-700 ${className}`}
      >
        <div className='flex items-center justify-center text-center mb-3 desktop:mb-4'>
          {Icon && <IconBox icon={Icon} size={isMobile ? 'medium' : 'large'} />}
        </div>
        <h3 className='text-base tablet:text-lg font-bold mb-2 tablet:mb-4 text-center min-h-[50px] flex items-center justify-center'>
          {title}
        </h3>
        <p className='text-sm tablet:text-base text-gray-300 text-center flex-1 min-h-[100px]'>
          {description}
        </p>
      </div>
    );
  }
);

Card.displayName = 'Card';

export default Card;
